import { BaseResolver } from "./BaseResolver";
import { IAttentionDayRepository } from "./attentiondays/IAttentionDayRepository";
import { IAuthenticationRepository } from "./authentication/IAuthenticationRepository";
import { ICanTranslate } from "./translations/ICanTranslate";
import { ILocalRepository } from "./app/ILocalRepository";
import { INavigateTo } from "./navigation/INavigateTo";
import { IVersionInfoRepository } from "./appVersion/IVersionInfoRepository";
import { ICanNotify } from "./notifications/ICanNotify";
import { ICanShowAlert } from "./notifications/IRequestAlert";
import { IEmployeeAbsenceRepository } from "./absences/IEmployeeAbsenceRepository";
import { IEmployeeGroupRepository } from "./employeeGroups/IEmployeeGroupRepository";
import { IEmployeeRepository } from "./employees/IEmployeeRepository";

// tslint:disable:naming-convention
class AppDependencies extends BaseResolver {
    get ICanNotify() { return this.resolve<ICanNotify>("ICanNotify"); }
    get ICanTranslate() { return this.resolve<ICanTranslate>("ICanTranslate"); }
    get ILocalRepository() { return this.resolve<ILocalRepository>("ILocalRepository"); }
    get ISessionRepository() { return this.resolve<ILocalRepository>("ISessionRepository"); }
    get INavigateTo() { return this.resolve<INavigateTo>("INavigateTo"); }
    get IAuthenticationRepository() { return this.resolve<IAuthenticationRepository>("IAuthenticationRepository"); }
    get IVersionInfoRepository() { return this.resolve<IVersionInfoRepository>("IVersionInfoRepository"); }
    get ICanShowAlert() { return this.resolve<ICanShowAlert>("ICanShowAlert"); }

    get IEmployeeAbsenceRepository() { return this.resolve<IEmployeeAbsenceRepository>("IEmployeeAbsenceRepository"); }
    get IEmployeeRepository() { return this.resolve<IEmployeeRepository>("IEmployeeRepository"); }
    get IAttentionDayRepository() { return this.resolve<IAttentionDayRepository>("IAttentionDayRepository"); }
    get IEmployeeGroupRepository() { return this.resolve<IEmployeeGroupRepository>("IEmployeeGroupRepository"); }
}

export const appDependencies = new AppDependencies();
